import statsigEnv from "./statsig-host";

export const EXPERIMENT_NAME = {
    ab_test: "ab_test",
    c2bSellLandingMobileNumber: "c2b_sell_landing_mobile_number",
    financeFirstCheckoutRevamp: "finance_first_checkout_revamp",
    showClpLoanCalculator: "msite_clp_loan_calculator",
    web_mobile_pre_bi_assistance: "web_mobile_pre_bi_assistance",
    servicing_bundle_revamp: "servicing_bundle_revamp",
    web_location_highlighting: `${statsigEnv()}_web_location_highlighting`,
    web_price_drop_msite: "web_price_drop_msite",
    web_price_drop_desktop: "web_price_drop_desktop",
    event_banners: `${statsigEnv()}_event_banners`,
    hubspot_assistance_desktop: `${statsigEnv()}_desktop_hubspot_assistance`,
    msite_refurb_visibility_cdp: `${statsigEnv()}_msite_refurb_visibility_cdp`,
    msite_bi2ph: `${statsigEnv()}_msite_bi2ph`,
    msite_product_pitching: `${statsigEnv()}_msite_product_pitching`,
    desktop_product_pitching: `${statsigEnv()}_desktop_product_pitching`,
    gallery_on_the_fly_desktop: `${statsigEnv()}_gallery_on_the_fly_desktop`,
    interstate_pitch_v2: `${statsigEnv()}_interstate_pitch_v2`,
    msite_cdp_ew: `${statsigEnv()}_msite_cdp_ew`,
    desktop_cdp_ew: `${statsigEnv()}_desktop_cdp_ew`,
    web_order_summary_vas_gift: `${statsigEnv()}_web_order_summary_vas_gift`,
    hubspot_assistance_msite: `${statsigEnv()}_msite_hubspot_assistance`,
    desktop_car_card: `${statsigEnv()}_desktop_car_card`,

    desktop_wishlist_adoption: `${statsigEnv()}_desktop_wishlist_adoption`,
    msite_wishlist_adoption: `${statsigEnv()}_msite_wishlist_adoption`,

    config_poc: `${statsigEnv()}_config_poc`,
    web_car_tour: `${statsigEnv()}_web_car_tour`,

    msite_cta_optimization: `${statsigEnv()}_msite_cta_optimization`,
    desktop_cta_optimization: `${statsigEnv()}_desktop_cta_optimization`,

    desktop_premium_features: `${statsigEnv()}_desktop_premium_features`,
    msite_premium_features: `${statsigEnv()}_msite_premium_features`,

    desktop_handover_charges: `${statsigEnv()}_desktop_handover_charges`,
    msite_handover_charges: `${statsigEnv()}_msite_handover_charges`,

    cdp_cta_reorder: `${statsigEnv()}_cdp_cta_reorder`,

    msite_single_page_td: `${statsigEnv()}_msite_single_page_td`,

    desktop_sorting_victoria: `${statsigEnv()}_desktop_sorting_victoria`,
    desktop_sorting_nsw: `${statsigEnv()}_desktop_sorting_nsw`,
    desktop_sorting_queensland: `${statsigEnv()}_desktop_sorting_queensland`,

    msite_sorting_victoria: `${statsigEnv()}_msite_sorting_victoria`,
    msite_sorting_nsw: `${statsigEnv()}_msite_sorting_nsw`,
    msite_sorting_queensland: `${statsigEnv()}_msite_sorting_queensland`,

    dealer_badge: `${statsigEnv()}_dealer_badge`,
    desktop_luxury_cars: `${statsigEnv()}_desktop_luxury_cars`,
    msite_luxury_cars: `${statsigEnv()}_msite_luxury_cars`,
    // config_poc: `${statsigEnv()}_config_poc`
    msite_chr_widget: `${statsigEnv()}_msite_chr_widget`,
    desktop_chr_widget: `${statsigEnv()}_desktop_chr_widget`,
    pre_approval_on_fly_desktop: `${statsigEnv()}_pre_approval_on_fly_desktop`,
    pre_approval_on_fly_msite: `${statsigEnv()}_pre_approval_on_fly_msite`,
    hide_imperfections_msite: `${statsigEnv()}_hide_imperfections_msite`,
    hide_imperfections_desktop: `${statsigEnv()}_hide_imperfections_desktop`,
    whatsapp_enabled: `${statsigEnv()}_whatsapp_enabled`,
    desktop_vehicle_base_price: `${statsigEnv()}_desktop_vehicle_base_price`,
    msite_vehicle_base_price: `${statsigEnv()}_msite_vehicle_base_price`,
    desktop_coming_soon: `${statsigEnv()}_desktop_coming_soon`,
    msite_coming_soon: `${statsigEnv()}_msite_coming_soon`,

    desktop_guest_checkout_removal: `${statsigEnv()}_desktop_guest_checkout_removal`,
    msite_guest_checkout_removal: `${statsigEnv()}_msite_guest_checkout_removal`,
    msite_stripe_gateway: `${statsigEnv()}_msite_stripe_gateway`,
    desktop_stripe_gateway: `${statsigEnv()}_desktop_stripe_gateway`
};

export const AB_TEST_VARIATIONS = {
    CONTROL: "CONTROL",
    VARIANT: "VARIANT",
    VARIANT_A: "VARIANT_A",
    VARIANT_B: "VARIANT_B"
};

export const SERVICING_VARIANT_MAPPING = {
    CONTROL: "OLD",
    VARIANT: "TESTING"
};

export const WEB_VIEW_EXPERIMENT_TO_REDUCER_MAPPING = {
    bi2Phone: "msiteBi2ph",
    msiteSinglePageTd: "msiteSinglePageTd"
};
